import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { LLTTFInvitationList, LLTTFInvitationQuery, LLTTFInvitationQueryDefaultValues } from 'src/app/components/invitations/llttf-invitations/llttf-invitation-list';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { AuthService } from 'src/app/services/auth.service';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-llttf-invitation-list',
    templateUrl: './llttf-invitation-list.component.html',
    styleUrls: ['./llttf-invitation-list.component.scss'],
    standalone: false
})
export class LlttfInvitationListComponent {
  llttfinvitationslist: LLTTFInvitationList[] = [];
  queryFilter: LLTTFInvitationQuery = LLTTFInvitationQueryDefaultValues();
  totalRecords: number = 0;
  columnsToDisplay = [
    'col1',
    'col2',
    'col3',
    'col4',
    'col5'
  ]
  //queryFilter:TagQueryFilter=TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef
  information: string = '';
  LLTTFUsers: any[] = [];
  orgList: any[] = [];
  pageName = CheckPageAccess.LLTTFINVITATIONS;
  showAddButton = true;

  constructor(private _llttfinvitationservice: LlttfInvitationService,
    private _userservice: UserService,
    private _orgservice: OrganizationService,
    private _authservice:AuthService)
  { }

  ngOnInit() {
    this.information = "<h4>Status Definitions</h4><br/><span>Active:</span> The link is currently Active and can be used by the participant.<br/><br/>"+
      "<span>Used:</span> The link has been used by the participant and is now inactive.<br/><br/>"+
      "<span>Withdrawn:</span> The link has been manually withdrawn by the organizer and cannot be used.<br/><br/>"+
      "<span>Expired:</span> The link has reached its expiry date and cannot be used.";

    this._userservice.getLLTTFFacilitatorUsers().subscribe({
      next:(response) => {
        this.LLTTFUsers = response;
      }
    });

    this._orgservice.getOrganizationForUser().subscribe({
      next:(response) => {
        this.orgList = response;
      }
    });

    this.showAddButton = this._authservice.getAccessControl().addLLTTFInvitation;
    this.search();
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex;
    this.queryFilter.PageSize = e.pageSize;
    this.searchWithFilters();
  }

  private searchWithFilters() {

    this._llttfinvitationservice.getAlLLTTFInvitations(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.llttfinvitationslist = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
      this.submitButton.nativeElement.click();
      event.preventDefault();
	  }
	}

  resetFilters() {
    this.queryFilter = LLTTFInvitationQueryDefaultValues();
    this.search();
  }

  search() {
    this.searchWithFilters();
  }
}
